export default class Tax {
    id = 0;
    name = '';
}